<template>
  <div id="layout">
    <TopBar></TopBar>
    <router-view class="content-wrap"></router-view>
    <Bottom></Bottom>
  </div>
</template>

<script>
import TopBar from '../components/TopBar';
import Bottom from '../components/Bottom';
export default {
  name: 'homePage',
  components: {
    TopBar,
    Bottom
  }
};
</script>

<style lang="scss" scoped>
#layout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
